export const BriefcaseIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M4.66536 3.33366V1.33366C4.66536 0.965472 4.96384 0.666992 5.33203 0.666992H10.6654C11.0336 0.666992 11.332 0.965472 11.332 1.33366V3.33366H13.9987C14.3669 3.33366 14.6654 3.63214 14.6654 4.00033V13.3337C14.6654 13.7019 14.3669 14.0003 13.9987 14.0003H1.9987C1.63051 14.0003 1.33203 13.7019 1.33203 13.3337V4.00033C1.33203 3.63214 1.63051 3.33366 1.9987 3.33366H4.66536ZM2.66536 10.667V12.667H13.332V10.667H2.66536ZM2.66536 9.33366H13.332V4.66699H2.66536V9.33366ZM5.9987 2.00033V3.33366H9.9987V2.00033H5.9987ZM7.33203 7.33366H8.66536V8.66699H7.33203V7.33366Z"
      fill="currentColor"
    />
  </svg>
);
